"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.share = void 0;
var _Observable = require("./Observable");
var share = exports.share = function share() {
  return function (source) {
    return (0, _Observable.mkObservable)(function (observer) {
      return source.subscribe({
        next: function next(i) {
          return observer.next(i);
        },
        error: function error(err) {
          return observer.error(err);
        },
        complete: function complete() {
          return observer.complete();
        }
      });
    });
  };
};